import { Typography } from "antd";
import { useEffect } from "react";
import { title } from "../styles";

export default function Forum(args) {
  useEffect(() => {
    args.setCurrent("forum");
    document.title = "Forum | Zenofy";
  }, [args]);

  return (
    <div style={{ marginTop: "4rem" }}>
      <Typography.Title style={title(args.device)}>Yakında...</Typography.Title>
    </div>
  );
}
